import './AlertBar.css';

import React from 'react';
import PropTypes from 'prop-types';
import {AlertBar as AxAlertBar} from '@brandwatch/axiom-components';

const AlertBar = ({
  bar: {
    message,
    type,
  },
  barEnabled,
  onRemoveClick,
}) => {
  if (!barEnabled || !message) {
    return null;
  }

  return (
    <div className="AlertBar">
      <AxAlertBar onRemoveClick={onRemoveClick} type={type}>
        {message}
      </AxAlertBar>
    </div>
  );
};

AlertBar.propTypes = {
  bar: PropTypes.shape({
    message: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    type: PropTypes.string
  }),
  barEnabled: PropTypes.bool.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
};

export default AlertBar;
